import { render, staticRenderFns } from "./gc-user-panel.vue?vue&type=template&id=25359889"
import script from "./gc-user-panel.vue?vue&type=script&lang=js"
export * from "./gc-user-panel.vue?vue&type=script&lang=js"
import style0 from "./gc-user-panel.vue?vue&type=style&index=0&id=25359889&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports